import ReviewCarousel from "../components/reviewCarousel";

const LeftAuthLayout = (props) => {
  
    return (
        <div className="col-lg-5">
            <div
                className="auth-left"
                style={{
                    background: `linear-gradient(179.62deg, rgba(30, 30, 30, 0) 46.38%, rgba(30, 30, 30, 0.6) 80.85%), url(${props.image})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    backgroundSize: "cover",
                }}
            >
                <h1 className="white-title" dangerouslySetInnerHTML={{ __html: props?.title }}>
               
                </h1>
                <ReviewCarousel />
            </div>
        </div>
    );
};

export default LeftAuthLayout;
